import { render } from "./CreateApiKey.vue?vue&type=template&id=84b9fe4c"
import script from "./CreateApiKey.vue?vue&type=script&lang=ts"
export * from "./CreateApiKey.vue?vue&type=script&lang=ts"
script.render = render

export default script